import { useQuery, useTRPC } from "@luckymenu/api-client/react";
import { useMemo } from "react";
import { floorCounts, floorPlan } from "../ordering/floor";
import { useLiveBoard } from "./use-live-board";

/**
 * The Tables tab (OP-06): every table in use by area, with its state
 * (free, occupied, bill requested, billed), amount and time seated, from the
 * floor plan and the live board. Live through the board's socket updates;
 * a table edited in More > Tables refreshes it through `table.updated`.
 */
export function useFloor() {
	const trpc = useTRPC();
	const tables = useQuery(trpc.staff.tables.list.queryOptions());
	const live = useLiveBoard();
	const areas = useMemo(
		() => (tables.data ? floorPlan(tables.data, live.board) : []),
		[tables.data, live.board],
	);
	const counts = useMemo(() => floorCounts(areas), [areas]);
	const error = tables.error ?? live.error;
	return {
		status:
			tables.data && live.status === "ready"
				? ("ready" as const)
				: error
					? ("error" as const)
					: ("loading" as const),
		error,
		retry: () => {
			void tables.refetch();
			live.retry();
		},
		areas,
		counts,
	};
}
